import { Card, CardBorderRadius, CardBorderStyle, CardHeaderTheme, CardTheme } from '@apply/components';
import { BrokerAgreementSummary } from '../../../../queries/brokerAgreementQueries';
import { AgreementBrokerDetails } from './components/AgreementBrokerDetails/AgreementBrokerDetails';
import { AgreementBorrowerDetails } from './components/AgreementBorrowerDetails/AgreementBorrowerDetails';
import { PrimaryEntityUpdate } from './components/PrimaryEntityUpdate/PrimaryEntityUpdate';
import '../../../../styles/_detailCard.scss';

/**
 * The selected B-Client agreement's broker and borrower, and its primary entity. Give it a key per agreement, so the
 * primary entity choice starts from that agreement's.
 */
export const BrokerAgreementCard = ({ summary }: { summary: BrokerAgreementSummary }) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Card
                header='B-Client'
                headerTheme={CardHeaderTheme.Blue}
                theme={CardTheme.White}
                borderStyle={CardBorderStyle.Solid}
                borderRadius={CardBorderRadius.Small}
                width='100%'
            >
                <div
                    className='borrowerSelectorCardColumns'
                    style={{ fontSize: '13px' }}
                >
                    {summary.broker && <AgreementBrokerDetails broker={summary.broker} />}
                    {summary.borrower && <AgreementBorrowerDetails borrower={summary.borrower} />}
                </div>
            </Card>
            <PrimaryEntityUpdate summary={summary} />
        </div>
    );
};
